module.exports = __webpack_public_path__ + "media/tags/smartsearch/checkbox_f-c4ee52d2a155a3ddcfae982199a871d0.png";